module.exports = __webpack_public_path__ + "img/saum_signalgelb_ral1003.169a9c0d.jpg";